(function() {
  'use strict';

  // ─────────────────────────────────────────────────
  // Cart Drawer
  // ─────────────────────────────────────────────────
  const drawer = document.querySelector('.js-drawer');
  const overlay = document.querySelector('.js-drawer-overlay');
  const cartBody = document.querySelector('.js-cart-body');
  const cartCount = document.querySelector('[data-cart-count]');
  const toast = document.querySelector('.js-toast');
  const toastText = document.querySelector('.js-toast-text');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Drawer-Toggle
  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-cart-toggle')) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest('.js-cart-close') || e.target.closest('.js-cart-close-link') || e.target.closest('.js-drawer-overlay')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  // ESC schließt
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // ─────────────────────────────────────────────────
  // Toast
  // ─────────────────────────────────────────────────
  function showToast(text) {
    if (!toast || !toastText) return;
    toastText.textContent = text;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 2200);
  }

  // ─────────────────────────────────────────────────
  // Helpers
  // ─────────────────────────────────────────────────
  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    const euros = cents / 100;
    const hasFraction = (cents % 100) !== 0;
    const formatted = hasFraction
      ? euros.toFixed(2).replace('.', ',')
      : Math.round(euros).toString();
    return formatted + ' €';
  }

  function imageThumb(item) {
    if (item.image) {
      const url = item.image.startsWith('//') ? 'https:' + item.image : item.image;
      const sized = url.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2');
      return '<img src="' + escapeHtml(sized) + '" alt="' + escapeHtml(item.product_title || '') + '" loading="lazy" width="80" height="80" style="object-fit:cover;width:100%;height:100%;border-radius:4px">';
    }
    return '<div class="media media-rose" style="width:100%;height:100%;border-radius:4px"></div>';
  }

  function renderCartBody(cart) {
    if (!cartBody) return;

    if (!cart || cart.item_count === 0) {
      cartBody.innerHTML = `
        <div class="drawer-body">
          <div class="drawer-empty">
            <h4>Dein Warenkorb ist leer</h4>
            <p>Schau dich um, vielleicht ist etwas Passendes dabei.</p>
            <a href="/" class="btn btn-ghost btn-sm js-cart-close-link">Weiter stöbern</a>
          </div>
        </div>`;
      return;
    }

    const itemsHtml = cart.items.map(item => {
      const eyebrow = escapeHtml(item.product_type || item.vendor || '');
      const title = escapeHtml(item.product_title || '');
      const variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-item-var">' + escapeHtml(item.variant_title) + '</div>'
        : '';
      return `
        <div class="cart-item" data-key="${escapeHtml(item.key)}">
          <div class="cart-item-img">${imageThumb(item)}</div>
          <div class="cart-item-body">
            <div class="cart-item-eb">${eyebrow}</div>
            <a href="${escapeHtml(item.url)}" class="cart-item-title">${title}</a>
            ${variantLine}
            <div class="cart-item-row">
              <span class="cart-item-price">${formatMoney(item.final_line_price)}</span>
              <button type="button" class="cart-rm js-cart-remove" data-key="${escapeHtml(item.key)}">Entfernen</button>
            </div>
          </div>
        </div>`;
    }).join('');

    cartBody.innerHTML = `
      <div class="drawer-body">
        ${itemsHtml}
      </div>
      <div class="drawer-foot">
        <div class="drawer-line">
          <span>Zwischensumme</span>
          <span>${formatMoney(cart.items_subtotal_price)}</span>
        </div>
        <div class="drawer-line">
          <span>Versand</span>
          <span>Wird im Checkout berechnet</span>
        </div>
        <div class="drawer-line total">
          <span>Gesamt</span>
          <span>${formatMoney(cart.total_price)}</span>
        </div>
        <a href="/checkout" class="btn btn-primary">Zur Kasse</a>
        <p class="drawer-note">Inkl. MwSt. · Versandkosten werden im Checkout berechnet</p>
      </div>`;
  }

  // ─────────────────────────────────────────────────
  // Cart neu laden (Body + Count)
  // ─────────────────────────────────────────────────
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        cartCount.dataset.count = cart.item_count;
      }
      renderCartBody(cart);
      return cart;
    } catch (err) {
      console.error('Cart-Refresh fehlgeschlagen:', err);
      return null;
    }
  }

  if (cartBody) {
    refreshCart();
  }

  // ─────────────────────────────────────────────────
  // Add to Cart (via Shopify AJAX API)
  // ─────────────────────────────────────────────────
  document.addEventListener('submit', async function(e) {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]') && form.id !== 'product-form') return;

    e.preventDefault();
    const formData = new FormData(form);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.description || 'Add to cart fehlgeschlagen');
      }

      const item = await response.json();
      await refreshCart();

      showToast((item.product_title || 'Produkt') + ' · zum Warenkorb');
      setTimeout(openDrawer, 200);
    } catch (err) {
      console.error(err);
      showToast('Hat leider nicht geklappt. Versuch es nochmal.');
    }
  });

  // ─────────────────────────────────────────────────
  // Cart Item Remove (im Drawer)
  // ─────────────────────────────────────────────────
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('.js-cart-remove');
    if (!btn) return;

    e.preventDefault();
    const key = btn.dataset.key;

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: 0 })
      });

      await refreshCart();
    } catch (err) {
      console.error(err);
    }
  });
})();
